import styled from 'styled-components';

import { Tabs } from 'components/tabs';

export const FormInner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
`;

export const Container = styled.div`
  flex: 1;
  display: flex;
  min-height: 0;
  padding: 16px;
  overflow-y: auto;
  overflow-x: hidden;
  flex-direction: column;
`;

export const StyledTabs = styled(Tabs)`
  padding: 0 16px;
`;

// POS Deals (26 Oct 2026): a minimum that would put a deal under its floor.
export const DealWarning = styled.div`
  margin-top: 4px;
  color: ${({ theme }) => theme.colors.red.primary.standard};
`;
